/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/explicit-function-return-type */

import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import axios from 'axios';
import { getAppointmentDateRange } from '../../pages/Calendars/utility_objects/AppointmentDateRange';
import { UserInterface } from '../../interfaces/User';

export const getPointOfSaleHoursShift = async (
  pointOfSaleId: string,
  selectedDate: Date,
  selectedUsers: UserInterface[],
  view: string
): Promise<any> => {
  try {
    const [startDate, endDate] = getAppointmentDateRange(selectedDate, view);

    const isSingleUser = selectedUsers.length === 1;
    if (isSingleUser) {
      const userId = selectedUsers[0].id;
      const {
        data: { data },
      } = await axios.post(
        `/api/ShiftUser${userId !== undefined ? `/${userId}` : ''}${
          pointOfSaleId !== undefined ? `/${pointOfSaleId}` : ''
        }?dc=${Date.now()}`,
        {
          startDate: startDate.format('YYYY-MM-DD'),
          endDate: endDate.format('YYYY-MM-DD'),
        }
      );
      return data.calendarList;
    }

    const {
      data: { data },
    } = await axios.post(
      `/api/ShiftPointOfSale/${pointOfSaleId ?? ''}?dc=${Date.now()}`,
      {
        startDate: startDate.format('YYYY-MM-DD'),
        endDate: endDate.format('YYYY-MM-DD'),
      }
    );
    return data;
  } catch (err) {
    console.trace(err);
    return [];
  }
};

export const usePointOfSaleHoursShift = ({
  pointOfSaleId,
  selectedDate,
  view = 'Day',
  options = {},
  selectedUsers = [],
  key = '',
}: {
  pointOfSaleId: string;
  selectedDate: Date;
  view?: string;
  selectedUsers: UserInterface[];
  options?: UseQueryOptions;
  key?: string; // Add this optional parameter to your useQuery hook.
}) => {
  return useQuery({
    queryFn: async () =>
      await getPointOfSaleHoursShift(
        pointOfSaleId,
        selectedDate,
        selectedUsers,
        view
      ),
    queryKey: [
      'point-of-sale-hours',
      'shift',
      pointOfSaleId,
      selectedUsers.map((user) => user.id).join(','),
      selectedDate,
      view,
      key,
    ],
    retry: 2,
    cacheTime: 0,
    staleTime: 0,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    select: normalize,
    ...options,
  });
};

const normalize = (result: any) => {
  if (result && result.length > 0) {
    const data: any = {};
    for (const day of result) {
      data[day.date] = day.hours;
    }
    return data;
  }
  return {};
};
